import React, {
  useState, forwardRef, useImperativeHandle, useEffect,
} from 'react';
import { useQuery, useLazyQuery } from 'react-apollo';
import { Link, useLocation } from 'react-router-dom';
import {
  Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Button,
} from 'reactstrap';
import { DebounceInput } from 'react-debounce-input';
import PropTypes from 'prop-types';
import {
  USER_ICON, staticConstants, routeConstants, NUMERIC_VALUE, bodyStyle,
} from '../../../utils';
import {
  ChangePassword, Logout, FilterByBrand, AudienceDemographics,
} from '../../modals';
import Sidebar from '../sidebar/Sidebar';
import { GET_CATEGORY_ADMIN_QUERY, GET_ADMIN_NOTIFICATION } from '../../../graphql-client/queries';
import { useChatMessageInitializer } from '../../../utils/chatMessageInitializer';
import { askForPermissioToReceiveNotifications, showMessage } from '../../../config/firebase';

import AnalyticsDuePost from '../analytics/AnalyticsDuePost';

const Header = forwardRef((props, ref) => {
  useChatMessageInitializer();
  const location = useLocation();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownProfileOpen, setDropdownProfileOpen] = useState(false);
  const [filterModal, setFilterModal] = useState(false);
  const [demographicsModal, setDemographicsModal] = useState(false);
  const [postDueModal, setPostDueModal] = useState(false);
  const [changePasswordModal, setChangePasswordModal] = useState(false);
  const [count, setCount] = useState(0);
  const [logoutModal, setLogoutModal] = useState(false);
  const [checkboxValue, setCheckboxValue] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [isNewRequest, setIsNewRequest] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [isReject, setIsReject] = useState(false);
  const [isDeactivate, setIsDeactivate] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [isLeadGeneration, setIsLeadGeneration] = useState(false);
  const [isBrandedContent, setIsBrandedContent] = useState(false);
  const [isAwareness, setIsAwareness] = useState(false);
  const [isPublic, setIsPublic] = useState(false);
  const [isPrivate, setIsPrivate] = useState(false);
  const [isAffiliate, setIsAffiliate] = useState(false);
  const [isExcludeExpiredOffer, setIsExcludeExpiredOffer] = useState(false);
  const [lastFilteredData, setLastFilteredData] = useState({});
  const [isDropDownFilterApply, setIsDropDownFilterApply] = useState(false);
  const [isDemoFilterApply, setDemoFilterApply] = useState(false);
  const [lastClickedIndex, setLastClickedIndex] = useState(0);
  const [filteredBrandApplyData, setFilteredBrandApplyData] = useState([]);
  const [isUnreadMessage, setIsUnreadMessage] = useState(false);
  const filterObj = JSON.parse(localStorage.getItem('appliedOfferFilter'));
  const {
    data: categoryData,
  } = useQuery(GET_CATEGORY_ADMIN_QUERY, { skip: props.pathName !== routeConstants.ADMIN_ARTIST });

  const [getAdminNotification, { data: adminNotificationRes }] = useLazyQuery(GET_ADMIN_NOTIFICATION, {
    pollInterval: NUMERIC_VALUE.TEN_THOUSAND,
  });

  const toggleDemographicsModal = () => {
    setDemographicsModal(!demographicsModal);
  };

  useEffect(() => {
    askForPermissioToReceiveNotifications();
    showMessage();
    getAdminNotification();
  }, []);

  const togglePostDueModal = () => {
    setPostDueModal(!postDueModal);
  };
  const toggleFilterModal = () => {
    setFilterModal(!filterModal);
  };
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const toggleProfile = () => setDropdownProfileOpen((prevState) => !prevState);
  const toggleChangePasswordModal = () => {
    setChangePasswordModal(!changePasswordModal);
  };
  const toggleLogoutModal = () => {
    setLogoutModal(!logoutModal);
  };
  const adminNotification = adminNotificationRes && adminNotificationRes.adminNotification;

  const searchRecord = (value) => {
    setSearchValue(value);
    if (props.pathName === routeConstants.ADMIN_OFFER) {
      props.search(value, checkboxValue, isExcludeExpiredOffer, isUnreadMessage);
    } else {
      props.search(value, checkboxValue, filteredBrandApplyData);
    }
  };

  useImperativeHandle(ref, () => ({
    setTotalCount(count) {
      setCount(count);
    },
  }));

  const filterByBrands = (filteredBrand, isDemoFilter) => {
    isDemoFilter && setLastFilteredData({
      followers: {
        facebook: filteredBrand.followers && filteredBrand.followers.facebook,
        instagram: filteredBrand.followers && filteredBrand.followers.instagram,
        youtube: filteredBrand.followers && filteredBrand.followers.youtube,
        twitter: filteredBrand.followers && filteredBrand.followers.twitter,
        spotify: filteredBrand.followers && filteredBrand.followers.spotify,
      },
      country: filteredBrand.country,
    });
    isDemoFilter && setDemoFilterApply(true);
    !isDemoFilter && setFilteredBrandApplyData(filteredBrand);
    props.search(searchValue, checkboxValue, filteredBrand, isDemoFilter);
  };

  const updateLastClickedIndex = (index) => {
    setLastClickedIndex(index);
  };
  /**
   * @description function will set the filter dropdown value
   * @property {string} key- Matched key.
   * @property {boolean} type- Set value key.
   */
  const setfilterValue = (key, type) => {
    switch (key) {
      case staticConstants.STATUS_TYPE.REQUESTED:
        setIsNewRequest(type);
        break;
      case staticConstants.STATUS_TYPE.ACTIVE:
        setIsActive(type);
        break;
      case staticConstants.STATUS_TYPE.REJECTED:
        setIsReject(type);
        break;
      case staticConstants.STATUS_TYPE.DEACTIVATED:
        setIsDeactivate(type);
        break;
      case staticConstants.STATUS_TYPE.DELETED:
        setIsDelete(type);
        break;
      case staticConstants.STATUS_TYPE.LEAD_GENERATION:
        setIsLeadGeneration(type);
        break;
      case staticConstants.STATUS_TYPE.BRANDED_CONTENT:
        setIsBrandedContent(type);
        break;
      case staticConstants.STATUS_TYPE.AWARENESS:
        setIsAwareness(type);
        break;
      case staticConstants.STATUS_TYPE.PUBLIC:
        setIsPublic(type);
        break;
      case staticConstants.STATUS_TYPE.PRIVATE:
        setIsPrivate(type);
        break;
      case staticConstants.STATUS_TYPE.AFFILIATE:
        setIsAffiliate(type);
        break;
      case staticConstants.STATUS_TYPE.EXPIRED_OFFER:
        setIsExcludeExpiredOffer(type);
        break;
      case staticConstants.STATUS_TYPE.UNREAD_MESSAGE_OFFER:
        setIsUnreadMessage(type);
        break;
      default:
        break;
    }
  };

  /**
   * @description function will set the filter and update the list accordingly.
   * @property {string} key- Matched key.
   */
  const changeValue = (event) => {
    let filterValue = [];
    if (checkboxValue && checkboxValue.length && !event.target.checked) {
      filterValue = checkboxValue.filter((key) => {
        if (key !== event.target.name) {
          return event.target.name;
        }
        setfilterValue(key, false);
        return null;
      });
    } else {
      if (checkboxValue && checkboxValue.length) {
        filterValue = checkboxValue;
      }
      filterValue.push(event.target.name);
      setfilterValue(event.target.name, true);
    }
    if ((filterValue.includes('isExcludeExpiredOffer') || filterValue.includes('isUnreadMessage'))
      && filterValue.length < NUMERIC_VALUE.TWO) {
      setIsDropDownFilterApply(false);
    } else if ((filterValue.includes('isExcludeExpiredOffer') && filterValue.includes('isUnreadMessage'))
      && filterValue.length < NUMERIC_VALUE.THREE) {
      setIsDropDownFilterApply(false);
    } else if (filterValue.length) {
      setIsDropDownFilterApply(true);
    } else {
      setIsDropDownFilterApply(false);
    }
    setCheckboxValue(filterValue);
    props.search(searchValue, filterValue, filteredBrandApplyData);
  };

  /**
   * @description function will call when the dropdown open, set default filter value.
   */
  const dropdownOpenChange = () => {
    checkboxValue.length && checkboxValue.forEach((elem) => {
      setfilterValue(elem, true);
    });
  };

  const setPreFilledValue = (checkboxAppliedValue) => {
    checkboxAppliedValue.filter((key) => {
      setfilterValue(key, true);
    });
  };

  useEffect(() => {
    if ((location && location.pathname === routeConstants.ADMIN_OFFER) && filterObj) {
      const checkboxAppliedValue = [...filterObj.audience, ...filterObj.campaign];
      filterObj.isExcludeExpiredOffer && checkboxAppliedValue.push('isExcludeExpiredOffer');
      filterObj.isUnreadMessage && checkboxAppliedValue.push('isUnreadMessage');
      setSearchValue(filterObj.searchKey);
      setCheckboxValue(checkboxAppliedValue);
      setPreFilledValue(checkboxAppliedValue);
      if ((filterObj.isExcludeExpiredOffer || filterObj.isUnreadMessage) && checkboxAppliedValue.length < NUMERIC_VALUE.TWO) {
        setIsDropDownFilterApply(false);
      } else if ((filterObj.isExcludeExpiredOffer && filterObj.isUnreadMessage) && checkboxAppliedValue.length < NUMERIC_VALUE.THREE) {
        setIsDropDownFilterApply(false);
      } else if (checkboxAppliedValue.length) {
        setIsDropDownFilterApply(true);
      }
    } else {
      localStorage.removeItem('appliedOfferFilter');
    }
  }, []);

  /**
   * @description function is used to display text according to post or list count values
   */
  const displayPostCountText = () => {
    let stringToReturn = staticConstants.HEADER_CONSTANTS.TOTAL;
    if (props.pathName === routeConstants.ADMIN_ANALYTICS) {
      if (count || props.count) {
        stringToReturn = staticConstants.HEADER_CONSTANTS.POSTED_TODAY;
      } else {
        stringToReturn = staticConstants.HEADER_CONSTANTS.NO_NEW_POSTS;
      }
    }
    return stringToReturn;
  };

  /**
   * @description remove the applied filter red dot on clear filter
   */
  const clearDemoFilter = () => {
    setDemoFilterApply(false);
    setLastFilteredData({
      followers: {},
    });
    const filteredBrand = {};
    props.search(searchValue, checkboxValue, filteredBrand, true);
  };

  return (
    <>
      <Sidebar
        offerNotification={adminNotification
          && adminNotification.offerNotification}
        artistRequestCount={adminNotification
          && adminNotification.artistRequest}
        managerRequestCount={adminNotification
          && adminNotification.managerRequest}
        analyticsPostCount={adminNotification
          && adminNotification.analyticsRequest}
        betaPostRequest={adminNotification
          && adminNotification.betaPostRequest}
        offerRequest={adminNotification
          && adminNotification.offerRequest}
      />
      <div className="header" style={{ paddingRight: bodyStyle.paddingRight }}>
        <div className="header-nav">
          <div className="header-nav-page-name">
            <h3>
              {staticConstants.ROLE_HEADER[props.pathName]}
            </h3>
            <span>
              {count || props.count}
              {' '}
              {displayPostCountText()}
            </span>
            {props.pathName === routeConstants.ADMIN_ARTIST && (
              <Link
                to={`${routeConstants.IMPORT_ARTIST}`}
                className="btn btn-add"
              >
                + Import Artists
              </Link>
            )}
            {props.pathName === routeConstants.ADMIN_MANAGER && (
              <Link
                to={`${routeConstants.IMPORT_MANAGER}`}
                className="btn btn-add"
              >
                + Import Labels
              </Link>
            )}
            {props.pathName === routeConstants.ADMIN_OFFER && props.count > 0 && (
              <Link
                to={`${routeConstants.CRETAE_OFFER}`}
                className="btn btn-add"
              >
                + New opportunity
              </Link>
            )}
          </div>
          <div className="header-nav-filter">
            {props.pathName === routeConstants.ADMIN_ARTIST
              && (
                <div className="header-nav-filter-btn-wrapper">
                  <Button
                    className={`${filteredBrandApplyData.length ? 'active' : 'unactive'}`}
                    type="button"
                    color="fade"
                    onClick={toggleFilterModal}
                  >
                    {staticConstants.HEADER_CONSTANTS.FILTER_BY_BRAND}
                  </Button>
                  <Button
                    className={`${isDemoFilterApply ? 'active' : 'unactive'}`}
                    type="button"
                    color="fade"
                    onClick={toggleDemographicsModal}
                  >
                    {staticConstants.HEADER_CONSTANTS.FILTER_BY_DEMOGRAPHICS}
                  </Button>
                </div>
              )}
            {props.pathName === routeConstants.ADMIN_ANALYTICS
              && (
                <div className="header-nav-filter-btn-wrapper">
                  <Button
                    type="button"
                    color="fade"
                    className={`${adminNotification
                      && adminNotification.duePost > 0 ? 'active' : 'unactive'}`}
                    onClick={togglePostDueModal}
                  >
                    {staticConstants.HEADER_CONSTANTS.POSTS_DUE_TODAY}
                  </Button>
                </div>
              )}
            {(props.pathName === routeConstants.ADMIN_ARTIST
              || props.pathName === routeConstants.ADMIN_MANAGER)
              && (
                <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                  <DropdownToggle
                    caret
                    onClick={dropdownOpenChange}
                    className={`${isDropDownFilterApply ? 'applied' : 'unactive'}`}
                  >
                    {staticConstants.HEADER_CONSTANTS.STATUS}
                  </DropdownToggle>
                  <DropdownMenu className="dropdown-theme status-dropdown">
                    <DropdownItem
                      header
                    >
                      {staticConstants.HEADER_CONSTANTS.FILTER_BY_STATUS}
                    </DropdownItem>
                    <label htmlFor="Request" className="input-container-green">
                      <input
                        name="requested"
                        onClick={changeValue}
                        checked={isNewRequest}
                        id="Request"
                        type="checkbox"
                      />
                      <span className="checkmark" />
                      {staticConstants.HEADER_CONSTANTS.NEW_REQUEST}
                    </label>
                    <label htmlFor="Active" className="input-container-green">
                      <input
                        name="active"
                        onClick={changeValue}
                        checked={isActive}
                        id="Active"
                        type="checkbox"
                      />
                      <span className="checkmark" />
                      {staticConstants.HEADER_CONSTANTS.ACTIVE}
                    </label>
                    <label htmlFor="Rejected" className="input-container-green">
                      <input
                        name="rejected"
                        onClick={changeValue}
                        checked={isReject}
                        id="Rejected"
                        type="checkbox"
                      />
                      <span className="checkmark" />
                      {staticConstants.HEADER_CONSTANTS.REJECTED}
                    </label>
                    <label htmlFor="Deactivated" className="input-container-green">
                      <input
                        name="deactivated"
                        onClick={changeValue}
                        checked={isDeactivate}
                        id="Deactivated"
                        type="checkbox"
                      />
                      <span className="checkmark" />
                      {staticConstants.HEADER_CONSTANTS.DEACTIVATED}
                    </label>
                    <label htmlFor="Deleted" className="input-container-green">
                      <input
                        name="deleted"
                        onClick={changeValue}
                        checked={isDelete}
                        id="Deleted"
                        type="checkbox"
                      />
                      <span className="checkmark" />
                      {staticConstants.HEADER_CONSTANTS.DELETED}
                    </label>
                  </DropdownMenu>
                </Dropdown>
              )}
            {(props.pathName === routeConstants.ADMIN_OFFER && props.count > 0) && (
              <>
                <div className="exclude-offer">
                  <div className="custom-control custom-switch small">
                    <input
                      id="expiredOfferFilter"
                      type="checkbox"
                      name="isExcludeExpiredOffer"
                      checked={isExcludeExpiredOffer}
                      className="custom-control-input"
                      onChange={changeValue}
                    />
                    <label htmlFor="expiredOfferFilter" className="custom-control-label" />
                    <em>Exclude expired</em>
                  </div>
                </div>
                <div className="exclude-offer">
                  <div className="custom-control custom-switch small">
                    <input
                      id="unreadMessageOfferFilter"
                      type="checkbox"
                      name="isUnreadMessage"
                      checked={isUnreadMessage}
                      className="custom-control-input"
                      onChange={changeValue}
                    />
                    <label htmlFor="unreadMessageOfferFilter" className="custom-control-label" />
                    <em>New messages</em>
                  </div>
                </div>
                <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                  <DropdownToggle
                    onClick={dropdownOpenChange}
                    className={`btn btn-fade ${isDropDownFilterApply ? 'applied' : 'unactive'}`}
                  >
                    Filter
                  </DropdownToggle>
                  <DropdownMenu className="dropdown-theme status-dropdown large">
                    <DropdownItem
                      header
                    >
                      Filter by campaign
                    </DropdownItem>
                    <label htmlFor="LeadGeneration" className="input-container-green">
                      <input
                        name="leadGeneration"
                        id="LeadGeneration"
                        type="checkbox"
                        onChange={changeValue}
                        checked={isLeadGeneration}
                      />
                      <span className="checkmark" />
                      Lead generation
                    </label>
                    <label htmlFor="BrandedContent" className="input-container-green">
                      <input
                        name="brandedContent"
                        id="BrandedContent"
                        type="checkbox"
                        onChange={changeValue}
                        checked={isBrandedContent}
                      />
                      <span className="checkmark" />
                      Branded content
                    </label>
                    <label htmlFor="Awareness" className="input-container-green">
                      <input
                        name="awareness"
                        id="Awareness"
                        type="checkbox"
                        onChange={changeValue}
                        checked={isAwareness}
                      />
                      <span className="checkmark" />
                      Awareness
                    </label>
                    <DropdownItem
                      header
                    >
                      Filter by audience
                    </DropdownItem>
                    <label htmlFor="Public" className="input-container-green">
                      <input
                        name="public"
                        id="Public"
                        type="checkbox"
                        onChange={changeValue}
                        checked={isPublic}
                      />
                      <span className="checkmark" />
                      Public
                    </label>
                    <label htmlFor="Private" className="input-container-green">
                      <input
                        name="private"
                        id="Private"
                        type="checkbox"
                        onChange={changeValue}
                        checked={isPrivate}
                      />
                      <span className="checkmark" />
                      Private
                    </label>
                    <label htmlFor="Affiliate" className="input-container-green">
                      <input
                        name="affiliate"
                        id="Affiliate"
                        type="checkbox"
                        onChange={changeValue}
                        checked={isAffiliate}
                      />
                      <span className="checkmark" />
                      Affiliate
                    </label>
                  </DropdownMenu>
                </Dropdown>
              </>
            )}
          </div>

          {(props.pathName === routeConstants.ADMIN_OFFER
            && props.count > 0)
            && (
              <div className="header-nav-search">
                <div className="search">
                  <DebounceInput
                    minLength={NUMERIC_VALUE.TWO}
                    type="search"
                    placeholder="Search by opportunity or client"
                    debounceTimeout={NUMERIC_VALUE.THREE_HUNDRED}
                    value={searchValue}
                    onChange={(event) => searchRecord(event.target.value)}
                  />
                  <span className="search-icon" />
                </div>
              </div>
            )}

          {(props.pathName === routeConstants.ADMIN_ARTIST
            || props.pathName === routeConstants.ADMIN_MANAGER)
            && (
              <div className="header-nav-search">
                <div className="search">
                  <DebounceInput
                    minLength={NUMERIC_VALUE.TWO}
                    type="search"
                    placeholder="Search"
                    debounceTimeout={NUMERIC_VALUE.THREE_HUNDRED}
                    onChange={(event) => searchRecord(event.target.value)}
                  />
                  <span className="search-icon" />
                </div>
              </div>
            )}
          <div className="header-nav-user">
            <Dropdown isOpen={dropdownProfileOpen} toggle={toggleProfile}>
              <DropdownToggle>
                <img src={USER_ICON} className="image-cover" alt="User profile" />
              </DropdownToggle>
              <DropdownMenu right className="dropdown-theme user-dropdown">
                <DropdownItem onClick={toggleChangePasswordModal}>Change password</DropdownItem>
                <DropdownItem onClick={toggleLogoutModal}>Sign out</DropdownItem>
              </DropdownMenu>
            </Dropdown>
            {changePasswordModal
              && (
                <ChangePassword
                  isOpen={changePasswordModal}
                  onClose={() => { toggleChangePasswordModal(); }}
                />
              )}
            {logoutModal
              && <Logout isOpen={logoutModal} role={staticConstants.ROLE.SYSTEM_ADMIN} onClose={() => { toggleLogoutModal(); }} />}
          </div>
        </div>
        {(filterModal && categoryData && categoryData.getCategory) && (
          <FilterByBrand
            isOpen={filterModal}
            categoryData={categoryData.getCategory.data}
            onClose={() => { toggleFilterModal(); }}
            filterByBrands={filterByBrands}
            lastClickedIndex={lastClickedIndex}
            updateLastClickedIndex={updateLastClickedIndex}
          />
        )}
        {demographicsModal && (
          <AudienceDemographics
            isOpen={demographicsModal}
            onClose={() => { toggleDemographicsModal(); }}
            filterByDemographics={filterByBrands}
            lastFilteredData={lastFilteredData}
            clearDemoFilter={clearDemoFilter}
          />
        )}
        {postDueModal && (
          <AnalyticsDuePost
            isOpen={postDueModal}
            isHide={() => { togglePostDueModal(); }}
          />
        )}
      </div>
    </>
  );
});

Header.propTypes = {
  count: PropTypes.number,
  pathName: PropTypes.string,
  search: PropTypes.func,
};
Header.defaultProps = {
  count: null,
  pathName: null,
  search: null,
};
export default Header;
